import { captureException } from 'Utils/errorTracking';

export const initialize = () => {
  /* eslint-disable */
  // Initialize the Helpscout Beacon
  !(function(e, t, n) {
    function a() {
      var e = t.getElementsByTagName('script')[0],
        n = t.createElement('script');
      (n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = 'https://beacon-v2.helpscout.net'),
        e.parentNode.insertBefore(n, e);
    }
    if (
      ((e.Beacon = n = function(t, n, a) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a });
      }),
      (n.readyQueue = []),
      'complete' === t.readyState)
    )
      return a();
    e.attachEvent
      ? e.attachEvent('onload', a)
      : e.addEventListener('load', a, !1);
  })(window, document, window.Beacon || function() {});
  /* eslint-enable */

  window.Beacon('config', {
    color: '#0390AB',
    messagingEnabled: true,
    docsEnabled: false,
    display: {
      iconImage: 'question',
      style: 'manual',
      position: 'right',
    },
    messaging: {
      chatEnabled: false,
      contactForm: {
        showSubject: true,
      },
    },
    labels: {
      sendAMessage: 'Send us a note',
      responseTime: 'We’ll respond as soon as possible.',
      howCanWeHelp: 'How can we help you?',
      contactSuccessDescription:
        'Thanks for reaching out. Someone from our team will get back to you as soon as possible.',
    },
  });
};

export const identifyUser = (user, schoolId) => {
  if (typeof window.Beacon !== 'undefined' && !user.isStudent) {
    try {
      window.Beacon('identify', {
        name: `${user.given_name} ${user.family_name}`,
        email: user.auth_info.username,
        id: user.id,
        school_id: schoolId,
      });
    } catch (e) {
      captureException(e);
    }
  }
};
